var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTappinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 126.808,
    height: 30,
    viewBox: "0 0 126.808 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a-logo{fill:#00ccc2;}.b-logo{fill:#f5f5f5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1035.743 -493.186)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a-logo",
    d: "M1051.334,507.028a8.216,8.216,0,0,1-2.646-.888,44.014,44.014,0,0,0-.283,5.329c0,.134-.031,2.726.232,5.6a1.956,1.956,0,1,0,3.9-.357c-.244-2.681-.217-5.171-.216-5.221,0-1.23.038-2.276.1-3.167h0a1.258,1.258,0,0,0-1.081-1.3",
    transform: "translate(-1.671 -1.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a-logo",
    d: "M1052.368,500.554a7.938,7.938,0,0,1,4.777-3.292,6.146,6.146,0,0,1,1.362-.163,3.286,3.286,0,0,1,1.112.163c-.464.9-2.838,2.765-7.251,3.292m10.024-6.143c-1.356-1.166-3.64-1.526-6.112-.965a11.856,11.856,0,0,0-8.211,6.822c-.04.073-.083.161-.13.265a23,23,0,0,1-9.13-3.962,1.944,1.944,0,0,0-2.584.336l0,0a1.956,1.956,0,0,0,.362,2.885,27.031,27.031,0,0,0,10.386,4.54,19.111,19.111,0,0,0,3.977.25c6.772-.274,11.344-3.238,12.409-6.144a3.521,3.521,0,0,0-.963-4.032",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b-logo",
    d: "M1085.6,499.531v4h3.616v3.463h-3.642v5.38c0,1.5.84,1.911,1.622,1.911a4.537,4.537,0,0,0,1.731-.348l.958,3.471a8.877,8.877,0,0,1-3.013.628c-3.088.144-5.431-1.213-5.431-5.661v-5.38H1078.9v-3.463h2.546v-4Z",
    transform: "translate(-5.697 -0.838)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b-logo",
    d: "M1104.639,503.98h3.9v14.284h-3.76l-.23-1.791a5.5,5.5,0,0,1-4.395,2.1c-4.278.034-7.376-2.742-7.376-7.452a7.03,7.03,0,0,1,7.494-7.46,4.835,4.835,0,0,1,4.219,1.96Zm-7.69,7.146a3.574,3.574,0,0,0,3.76,3.752,3.773,3.773,0,1,0,0-7.545,3.6,3.6,0,0,0-3.76,3.794",
    transform: "translate(-7.529 -1.383)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b-logo",
    d: "M1114.664,524.583V504.027h3.726l.262,1.817a5.429,5.429,0,0,1,4.737-2.08c4.193,0,7.061,2.953,7.061,7.4,0,4.626-2.92,7.427-7.112,7.427a5.68,5.68,0,0,1-4.481-2.02v8.012Zm11.593-13.418a3.4,3.4,0,0,0-3.5-3.675c-1.884,0-3.853.959-3.853,3.675a3.662,3.662,0,0,0,3.853,3.675,3.4,3.4,0,0,0,3.5-3.675",
    transform: "translate(-10.418 -1.396)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b-logo",
    d: "M1135.647,524.583V504.027h3.726l.263,1.817a5.426,5.426,0,0,1,4.736-2.08c4.193,0,7.061,2.953,7.061,7.4,0,4.626-2.92,7.427-7.113,7.427a5.679,5.679,0,0,1-4.48-2.02v8.012Zm11.593-13.418a3.4,3.4,0,0,0-3.5-3.675c-1.884,0-3.853.959-3.853,3.675a3.662,3.662,0,0,0,3.853,3.675,3.4,3.4,0,0,0,3.5-3.675",
    transform: "translate(-13.188 -1.396)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b-logo",
    d: "M1161.033,499.312a2.368,2.368,0,0,1-4.736,0,2.368,2.368,0,0,1,4.736,0m-4.447,18.069h4.159V503.072h-4.159Z",
    transform: "translate(-15.914 -0.499)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b-logo",
    d: "M1175.442,518.259v-7.546c0-2.2-.95-3.326-2.945-3.326a3.317,3.317,0,0,0-3.241,3.5v7.374h-4.1V503.975h3.759l.145,1.825a5.4,5.4,0,0,1,4.625-2.173c3.208,0,5.949,1.511,5.949,7.061v7.571Z",
    transform: "translate(-17.083 -1.378)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTappinLogo);
export default __webpack_public_path__ + "static/media/tappin-logo.37176963b5f2e3960d7c638f1d41d925.svg";
export { ForwardRef as ReactComponent };